// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1534e23b","453":"9b90c8f3","732":"dd8c304d","977":"81a2798d"}[chunkId] + ".chunk.js";
};